/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { CookiesProvider } from "react-cookie";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { AzureADProvider } from "cms/auth/context/AzureADContext";
import { msalConfig } from "cms/auth/authConfig";
import { Routes } from "sections/routes";
import { WelcomeRoutes } from "Welcome/welcome-routes";
import { ScrollTop } from "components/ScrollTop";
import { SessionCheck } from "cms/auth/session-check";
import { ThemeCustomization } from "themes";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import Config from "data/config";
import "data/lang/i18n";
import { Provider as ReduxProvider } from "react-redux/es/exports";
import { store } from "./data/store";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { SimpliCityToast } from "./cms/common/ui-components/toast";

const msalInstance = new PublicClientApplication(msalConfig);

const AdminConsole = () => {
    const { i18n } = useTranslation();
    const server_url = Config.API_BASEURL;
    const version = Config.version;
    const sdk_version = SimpliCityAdminSDK.version;
    console.info(`Starting SimplicityAdmin Console [version: ${version}] [Admin SDK: ${sdk_version}] with API @ ${server_url}`);
    // Logger.info(`Starting SimplicityAdmin Console [version: ${version}] [AdminSDK: ${sdk_version}] with API @ ${server_url}`);
    
    return (
        <ReduxProvider store={store}>
            <BrowserRouter basename='/'>
                <CssBaseline />
                <SimpliCityToast />
                <LocalizationProvider
                    dateLibInstance={dayjs}
                    dateAdapter={AdapterDayjs}
                    adapterLocale={i18n.language}
                >
                    <ThemeCustomization>
                        <WelcomeRoutes />
                        <CookiesProvider>
                            <DndProvider backend={HTML5Backend}>
                                <ScrollTop>
                                    <MsalProvider instance={msalInstance}>
                                        <AzureADProvider>
                                            <SessionCheck>
                                                <Routes />
                                            </SessionCheck>
                                        </AzureADProvider>
                                    </MsalProvider>
                                </ScrollTop>
                            </DndProvider>
                        </CookiesProvider>
                    </ThemeCustomization>
                </LocalizationProvider>
            </BrowserRouter>
        </ReduxProvider>
    );
};
console.log("SimpliCity Composer is built by Simplicity Digital in Canada.");
export { AdminConsole };
